import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {NgOptimizedImage} from '@angular/common';

@Component({
    selector: 'page-landing',
    imports: [
        RouterLink,
        NgOptimizedImage
    ],
    templateUrl: './landing.page.html',
    styleUrl: './landing.page.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { 'class': 'landing-container' }
})
export class LandingPage {
  /** Rouvre le bandeau de consentement (consentmanager.net) pour changer ou retirer son choix. Le lien `?cmpscreen=1`
   *  ne sert que de secours : relatif au <base href>, il mene a la racine, et l'app redirige avant que le bandeau le lise. */
  manageCookies(event: Event) {
    const cmp = (window as any).__cmp;
    if (typeof cmp === 'function') {
      event.preventDefault();
      cmp('showScreen');
    }
  }
}
